import {
  guide_tour_init,
  guide_tour_step_start,
  guide_tour_step,
  guide_tour_step_click_button,
  guide_tour_step_complete,
} from "@/guide/utils/guide_tour_actions";

export async function guide_compte_licences(langs) {
  let translations;
  try {
    translations = (
      await import(`@/guide/traductions/guide_traduction_${langs}.json`)
    ).default;
  } catch (error) {
    console.error("Erreur lors du chargement des traductions pour la langue", langs, error);
    return;
  }

  // Forcer la vue cartes au démarrage
  const btnCards = document.getElementById("btn-cards-view");
  if (btnCards) btnCards.click();

  const tour = guide_tour_init();
  const t = translations.compte.licences;

  // Étape 1 — Barre de navigation (tabs du compte)
  guide_tour_step_start(
    tour,
    translations,
    translations.compte.barreNavigation.titre,
    translations.compte.barreNavigation.texte,
    `#${(document.getElementById("fils_barreNavigation").parentElement.id = "barreNavigation")}`,
    "bottom"
  );

  // Étape 2 — Boutons bascule de vue
  guide_tour_step(tour, translations, t.vueToggle.titre, t.vueToggle.texte, "#licences-barre-vue", "bottom");

  // Étape 3 — Toggle licences périmées
  guide_tour_step(tour, translations, t.toggleExpired.titre, t.toggleExpired.texte, "#licences-toggle-expired", "bottom");

  // Étape 4 — Vue par machine : aperçu global
  guide_tour_step(tour, translations, t.vueCards.titre, t.vueCards.texte, "#licences-cards", "top");

  // Étape 5 — Détail d'une carte (première carte du DOM)
  guide_tour_step(
    tour,
    translations,
    t.carteDetail.titre,
    t.carteDetail.texte,
    document.querySelector("#licences-cards .p-card"),
    "right"
  );

  // Étape 6 — Toggle machines masquées (visible uniquement en vue cartes)
  guide_tour_step(tour, translations, t.toggleHidden.titre, t.toggleHidden.texte, "#licences-toggle-hidden", "bottom");

  // Étape 7 — Passage à la vue tableau (clic sur btn-table-view au Suivant)
  guide_tour_step_click_button(
    tour,
    translations,
    t.switchTableau.titre,
    t.switchTableau.texte,
    "#licences-barre-vue",
    "bottom",
    "btn-table-view"
  );

  // Étape 8 — Vue tableau
  guide_tour_step(tour, translations, t.vueTableau.titre, t.vueTableau.texte, "#licences", "top");

  // Étape 9 — Bouton CSV
  guide_tour_step_complete(tour, translations, t.csv.titre, t.csv.texte, "#btn-download-csv", "bottom");

  tour.start();
}
